import moment from "moment";
import { useEffect, useState } from "react";
import { Alert, Col, Form, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { SubmitButton } from "../components/btns";
import { ErrorLoading, PageLoading } from "../components/loading";
import { getPublicRegistration, submitPublicRegistration } from "../resources/api/events";
import PublicEventLayout from "./public-event-layout";

const emptyRegistration = { full_name: "", email: "", phone: "", organisation: "", job_title: "" };
const bool = value => value === true || value === 1 || value === "1";

const EventRegistration = () => {
    const { shortCode } = useParams();
    const [event, setEvent] = useState(null);
    const [details, setDetails] = useState(emptyRegistration);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [validated, setValidated] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [complete, setComplete] = useState(false);

    useEffect(() => {
        getPublicRegistration(shortCode)
            .then(({ event }) => setEvent({ ...event, start_date: event.start_date ? moment(event.start_date).format("DD MMM YYYY") : "" }))
            .catch(setError)
            .finally(() => setLoaded(true));
    }, [shortCode]);

    const change = e => {
        const { name, value } = e.currentTarget;
        setDetails(details => ({ ...details, [name]: value }));
    };
    const submit = e => {
        e.preventDefault();
        if (!e.currentTarget.checkValidity()) return setValidated(true);
        setSubmitting(true);
        submitPublicRegistration(shortCode, details)
            .then(() => setComplete(true))
            .catch(setError)
            .finally(() => setSubmitting(false));
    };

    if (!loaded) return <PageLoading>Loading event registration...</PageLoading>;
    if (error && !event) return <ErrorLoading>{error}</ErrorLoading>;

    return (
        <PublicEventLayout event={event}>
            {complete ? (
                <div className="text-center py-4">
                    <i className="fas fa-circle-check fa-4x text-success mb-3" />
                    <h2 className="h4">Registration complete</h2>
                    <p className="text-muted mb-0">Thank you, {details.full_name}. Your registration has been received.</p>
                </div>
            ) : !bool(event?.registrationOpen) ? (
                <Alert variant="secondary" className="mb-0 text-center">Registration for this event is currently closed.</Alert>
            ) : (
                <>
                    <h2 className="h5 mb-1">Register for this event</h2>
                    <p className="text-muted mb-4">Enter your details below. Fields marked with * are required.</p>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form noValidate validated={validated} onSubmit={submit}>
                        <Row className="g-3">
                            <Col xs={12}>
                                <Form.Label>Full name *</Form.Label>
                                <Form.Control name="full_name" value={details.full_name} onChange={change} autoComplete="name" required />
                                <Form.Control.Feedback type="invalid">Please enter your full name.</Form.Control.Feedback>
                            </Col>
                            <Col sm={6}><Form.Label>Email</Form.Label><Form.Control type="email" name="email" value={details.email} onChange={change} autoComplete="email" /><Form.Control.Feedback type="invalid">Enter a valid email address.</Form.Control.Feedback></Col>
                            <Col sm={6}><Form.Label>Telephone</Form.Label><Form.Control type="tel" name="phone" value={details.phone} onChange={change} autoComplete="tel" /></Col>
                            <Col sm={6}><Form.Label>Organisation</Form.Label><Form.Control name="organisation" value={details.organisation} onChange={change} autoComplete="organization" /></Col>
                            <Col sm={6}><Form.Label>Job title</Form.Label><Form.Control name="job_title" value={details.job_title} onChange={change} autoComplete="organization-title" /></Col>
                            <Col xs={12} className="text-end mt-4"><SubmitButton type="submit" isSubmitting={submitting}>Complete Registration</SubmitButton></Col>
                        </Row>
                    </Form>
                </>
            )}
        </PublicEventLayout>
    );
};

export default EventRegistration;
